/** @format */

import * as actionTypes from 'stateContainer/action-types';

const initialState = {
  sessionEndTime: 0,
  isAuthenticated: false,
  requesting: false,
  data: {
    accessToken: '',
    refreshToken: '',
    userData: {}
  },
  loginError: null,
  logoutError: null,
  username: '',
  password: '',
  session: null
};

export const loginReducer = (state = initialState, action) => {
  const isRequestingState = {
    ...state,
    requesting: true
  };

  switch (action.type) {
    case actionTypes.LOGIN_REQUESTED:
      return isRequestingState;

    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        sessionEndTime: action.sessionEndTime,
        requesting: false,
        data: action.data
      };

    case actionTypes.LOGIN_FAILED:
      return {
        ...state,
        isAuthenticated: false,
        requesting: false,
        data: action.data || initialState.data,
        loginError: action.error,
        errorCode: action.errorCode
      };
    case actionTypes.CLEAR_LOGIN_STATE:
      return { ...initialState };

    case actionTypes.LOGOUT_REQUESTED:
      return { ...initialState };

    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        data: initialState.data,
        requesting: false,
        logoutError: null,
        isAuthenticated: false,
        sessionEndTime: initialState.sessionEndTime
      };

    case actionTypes.LOGOUT_FAILED:
      return { ...initialState, logoutError: action.error };

    case actionTypes.SAVE_USERNAME:
      return {
        ...initialState,
        username: action.username,
        password: action.password,
        session: action.session
      };

    default:
      return state;
  }
};
